/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoExternalUpdateShipmentInfoInput = {
    clientMutationId?: string | null;
    slug: string;
    expectedHandoverDate?: string | null;
    deliveryLocation?: string | null;
};
export type ExternalShipmentInfoCardMutationVariables = {
    input: infoExternalUpdateShipmentInfoInput;
};
export type ExternalShipmentInfoCardMutationResponse = {
    readonly infoExternalUpdateShipmentInfo: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ExternalShipmentInfoCardMutation = {
    readonly response: ExternalShipmentInfoCardMutationResponse;
    readonly variables: ExternalShipmentInfoCardMutationVariables;
};



/*
mutation ExternalShipmentInfoCardMutation(
  $input: infoExternalUpdateShipmentInfoInput!
) {
  infoExternalUpdateShipmentInfo(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoExternalUpdateShipmentInfoPayload",
    "kind": "LinkedField",
    "name": "infoExternalUpdateShipmentInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalShipmentInfoCardMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalShipmentInfoCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "49b7cadaf19ee0e4b0035fa9e3d1d78f",
    "id": null,
    "metadata": {},
    "name": "ExternalShipmentInfoCardMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalShipmentInfoCardMutation(\n  $input: infoExternalUpdateShipmentInfoInput!\n) {\n  infoExternalUpdateShipmentInfo(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bd3ee44f3cb2bd5918a7a9d928c4017a';
export default node;
